import { computed, inject, ref, watch } from 'vue';
import { IKApplicationPersistentData } from '@/services/persistentDataProvider/persistentDataProvider.types';

export const useMinimizedHeader = () => {
  type WorkloadViewPagePersistentDataType = {
    minimized: boolean;
  };

  const workloadViewPagePersistentDataSection = 'WorkloadViewPage';
  const applicationPersistentData = inject(IKApplicationPersistentData);
  const workloadViewPageData = ref({ minimized: false } as WorkloadViewPagePersistentDataType);

  watch(
    () => applicationPersistentData?.GQL?.networkStatus?.value,
    () => {
      const result = applicationPersistentData?.getPersistentData(workloadViewPagePersistentDataSection) as WorkloadViewPagePersistentDataType;
      if (result && typeof result === 'object' && Object.keys(result).length > 0) {
        workloadViewPageData.value = result;
      }
    },
    {
      immediate: true,
    },
  );

  const minimized = computed(() => workloadViewPageData.value.minimized);

  const setMinimized = (value: boolean) => {
    workloadViewPageData.value.minimized = value;
    applicationPersistentData?.setPersistentData(workloadViewPagePersistentDataSection, {
      minimized: value,
    });
  };

  return [minimized, setMinimized] as const;
};
